import React from 'react';
import { Avatar } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import {
  ResultAvatarWrapper,
  ResultName,
  ResultSubtext,
  ResultText,
} from '../styles';
import { InteractiveResultRow } from './InteractiveResultRow';
import type { UserSearchHit } from '../types';

interface UserResultProps {
  result: UserSearchHit;
  resultRef?: React.Ref<HTMLDivElement>;
  onSelect?: (userId: string) => void;
}

export const UserResult: React.FC<UserResultProps> = ({
  result,
  resultRef,
  onSelect,
}) => {
  const handleSelect = onSelect ? () => onSelect(result.entityId) : undefined;

  return (
    <InteractiveResultRow resultRef={resultRef} onSelect={handleSelect}>
      <ResultAvatarWrapper>
        <Avatar
          size="small"
          src={result.avatarUrl ?? undefined}
          icon={<FontAwesomeIcon icon={faUser} />}
          alt=""
          data-testid="search-overlay-user-avatar"
        />
      </ResultAvatarWrapper>
      <ResultText>
        <ResultName>{result.displayName}</ResultName>
        {result.email && <ResultSubtext>{result.email}</ResultSubtext>}
      </ResultText>
    </InteractiveResultRow>
  );
};
